import { ScaffoldPage } from '@/components/layout/ScaffoldPage'
import { buildBreadcrumbs } from '@/config/routes'

export default function Audit() {
  return (
    <ScaffoldPage
      title="Access Audit Log"
      description="Track team member actions and access patterns across your organization."
      breadcrumbs={buildBreadcrumbs('/settings/team/audit')}
      plannedFeatures={[
        'Filterable audit log by user, action, and date range',
        'Login history and session tracking',
        'Permission change tracking',
        'Export audit data for compliance reporting',
      ]}
      relatedPages={[
        { label: 'Team Members', href: '/settings/team/members' },
        { label: 'Roles & Permissions', href: '/settings/team/roles' },
        { label: 'Global Audit Log', href: '/settings/compliance/audit' },
      ]}
    />
  )
}
